import { ModalProps } from '../../components/Modal/Modal';

const InitialModal: ModalProps = {
  visible: false,
};

export default InitialModal;
